import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  constructor() {}
}
